import { TranslatorContext } from './jhipster-language';
import enForm from './en/form.json';
import enGeneral from './en/general.json';
import enGlobal from './en/global.json';
import enCard from './en/card.json';
import enError from './en/error.json';
import prsForm from './prs/form.json';
import prsGeneral from './prs/general.json';
import prsGlobal from './prs/global.json';
import prsCard from './prs/card.json';
import prsError from './prs/error.json';
import psForm from './ps/form.json';
import psGeneral from './ps/general.json';
import psGlobal from './ps/global.json';
import psCard from './ps/card.json';
import psError from './ps/error.json';
const isPlainRecord = (v) => v != null && typeof v === 'object' && !Array.isArray(v);
function deepMerge(target, source) {
    const out = { ...target };
    for (const k of Object.keys(source)) {
        const sv = source[k];
        const tv = out[k];
        if (isPlainRecord(tv) && isPlainRecord(sv)) {
            out[k] = deepMerge(tv, sv);
        }
        else {
            out[k] = sv;
        }
    }
    return out;
}
const mergeBundles = (...parts) => parts.reduce((acc, part) => deepMerge(acc, part), {});
export const CMS_LOCALES = ['en', 'prs', 'ps'];
/** Map onepay host `locale.currentLocale` / `Storage.session('locale')` keys to CMS bundles (`prs` / `ps`). */
export function hostLocaleToCmsLocale(hostLocale) {
    if (!hostLocale) {
        return 'en';
    }
    if (hostLocale === 'fa') {
        return 'prs';
    }
    if (hostLocale === 'ar-ly') {
        return 'ps';
    }
    if (hostLocale === 'en') {
        return 'en';
    }
    return 'en';
}
export const registerCmsTranslations = () => {
    TranslatorContext.setDefaultLocale('en');
    TranslatorContext.setRenderInnerTextForMissingKeys(false);
    TranslatorContext.registerTranslations('en', mergeBundles(enForm, enGeneral, enGlobal, enCard, enError));
    TranslatorContext.registerTranslations('prs', mergeBundles(prsForm, prsGeneral, prsGlobal, prsCard, prsError));
    TranslatorContext.registerTranslations('ps', mergeBundles(psForm, psGeneral, psGlobal, psCard, psError));
};
